module.exports = __webpack_public_path__ + "img/scientist.be5030ca.webp";